import MUIDataTable from 'mui-datatables'
import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { titleCase } from 'title-case'

import { Container } from 'src/modules/ui'
import {
  formatDate,
  formatDateSearch,
  formatPrice,
  generateOrderNumber,
} from 'src/utils'

const SubmittedOrderList = ({ orders }) => {
  const history = useHistory()

  const data = orders.map(order => {
    const {
      createdAt,
      user,
      price,
      status,
      statusChangedAt,
      supplier,
      scheduleLater,
    } = order
    console.log(order)
    return {
      ...order,
      id: generateOrderNumber(order),
      createdAt: formatDateSearch(createdAt),
      statusChangedAt: statusChangedAt && formatDateSearch(statusChangedAt),
      price: formatPrice(price),
      supplier: supplier.name,
      status: titleCase(status.replace(/_/g, ' ')),
      user: `${user.firstName} ${user.lastName}`,
      scheduleLater: scheduleLater && formatDate(scheduleLater),
    }
  })

  const columns = [
    {
      name: 'id',
      label: 'Order Number',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'supplier',
      label: 'Supplier',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'price',
      label: 'Amount (£)',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'user',
      label: 'Submitted By',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'createdAt',
      label: 'Date Submitted',
      options: {
        filter: false,
        sort: true,
        sortDirection: 'asc',
      },
    },
    // {
    //   name: 'statusChangedAt',
    //   label: 'Date Updated',
    //   options: {
    //     filter: false,
    //     sort: true,
    //   },
    // },
    {
      name: 'scheduleLater',
      label: 'Requested Date',
      options: {
        filter: false,
        sort: true,
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    onRowClick: (row, { dataIndex }) => {
      history.push(`/purchasing/submitted/${orders[dataIndex].id}`)
    },
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: 'none',
    viewColumns: false,
  }

  return (
    <Container muiTable>
      <MUIDataTable
        columns={columns}
        data={data}
        options={options}
        title="Submitted Orders"
      />
    </Container>
  )
}

SubmittedOrderList.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      createdAt: PropTypes.string,
      price: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    })
  ),
}

export default SubmittedOrderList
